import { FeeFormValue, Fee } from '../types';

export const convertFeeFormValueToFee = ({ fee, identifier, financed }: FeeFormValue): Fee => ({
  fee: Number(fee),
  identifier,
  financed,
});
